<template>
  <div class="SERiskComponent">
    <p>
      <b>{{ lang.infotext_1 }}:</b> {{ this.dataBasic.MPN }}<br />
      <b>{{ lang.infotext_2 }}:</b> {{ this.dataBasic.Manufacturer }}
    </p>
    <div>
      <!-- <b-tabs content-class="mt-3">
        <b-tab title="Risks" active> -->
      <b-card-group deck>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          :border-variant="statusOverall"
          header="Overall Risk"
          class="text-center"
          :header-bg-variant="statusOverall"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.OverallRisk }}
            </p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Lifecycle Risk"
          :border-variant="statusLifecycleRisk"
          class="text-center"
          :header-bg-variant="statusLifecycleRisk"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.LifecycleRisk }}</p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          :border-variant="statusInventory"
          header="Inventory"
          class="text-center"
          :header-bg-variant="statusInventory"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.InventoryRisk }}</p></b-card-text
          >
        </b-card>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Last Update Date "
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.LastUpdateDate }}</p></b-card-text
          >
        </b-card>
      </b-card-group>
      <b-card-group deck>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Lifecycle Stage"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.LifecycleStage }}</p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="MultiSourcing"
          class="text-center"
          :border-variant="statusMultiSourcing"
          :header-bg-variant="statusMultiSourcing"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.MultiSourcingRisk }}</p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Number Of Distributors"
          class="text-center"
          :border-variant="statusNumberOfDistributors"
          :header-bg-variant="statusNumberOfDistributors"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.NumberOfDistributors }}
            </p></b-card-text
          >
        </b-card>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Number Of Other Sources"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.NumberOfOtherSources }}
            </p></b-card-text
          >
        </b-card>
      </b-card-group>
      <b-card-group deck>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Predicted Obsolescence Year "
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.PredictedObsolescenceYear }}
            </p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          :border-variant="statusRohsRisk"
          header="Rohs Risk"
          class="text-center"
          :header-bg-variant="statusRohsRisk"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.RohsRisk }}</p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="SE Grade"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.SEGrade }}</p></b-card-text
          >
        </b-card>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Years EOL"
          class="text-center"
          :border-variant="statusYearsEOL"
          :header-bg-variant="statusYearsEOL"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.YearsEOL }}</p></b-card-text
          >
        </b-card>
      </b-card-group>
      <!-- </b-tab>
        <b-tab title="Lifecycle"> -->
      <b-card-group deck>
        <!-- <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          :border-variant="statusLifecycle"
          header="Lifecycle"
          class="text-center"
          :header-bg-variant="statusLifecycle"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.YeolComment }}</p></b-card-text
          >
        </b-card> -->

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Estimated EOL Date"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.EstimatedEOLDate }}
            </p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          :border-variant="statusEstimatedYearsToEOL"
          header="Estimated Years To EOL"
          class="text-center"
          :header-bg-variant="statusEstimatedYearsToEOL"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.EstimatedYearsToEOL }}
            </p></b-card-text
          >
        </b-card>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="LTB Date"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.LTBDate }}</p></b-card-text
          >
        </b-card>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="LifeCycle Risk Grade"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.RiskGrade }}</p></b-card-text
          >
        </b-card>
      </b-card-group>

      <b-card-group deck>
        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          border-variant="gray"
          header="Maximum Estimated Years To EOL"
          class="text-center"
          header-bg-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.MaximumEstimatedYearsToEOL }}
            </p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Minimum Estimated Years To EOL"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorder">
              {{ readyData.MinimumEstimatedYearsToEOL }}
            </p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          :border-variant="statusPartStatus"
          header="PartStatus"
          class="text-center"
          :header-bg-variant="statusPartStatus"
        >
          <b-card-text
            ><p class="cardBorder">{{ readyData.PartStatus }}</p></b-card-text
          >
        </b-card>

        <b-card
          :bg-variant="cardColorsBg"
          :text-variant="cardColorsText"
          header="Yeol Comment"
          class="text-center"
          header-bg-variant="gray"
          border-variant="gray"
        >
          <b-card-text
            ><p class="cardBorderComment">
              {{ readyData.YeolComment }}
            </p></b-card-text
          >
        </b-card>
      </b-card-group>
      <!-- </b-tab>
      </b-tabs> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SERiskComponent",
  props: {
    lang: Object,
    data: Object,
  },
  components: {},
  data() {
    return {
      transparent: "transparent",
      white: "white",
      readyData: {},
      dataBasic: {},
    };
  },
  computed: {
    ...mapGetters({
      globalSettings: "globalSettings",
    }),
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }
    },
    colors() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return ["tabs-bg-dark", "tabs-text-light"];
      } else {
        return ["tabs-bg-light", "tabs-text-dark"];
      }
    },
    textColors() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return ["tabs-bg-dark", "tabs-text-light"];
      } else {
        return ["tabs-bg-light", "tabs-text-dark"];
      }
    },
    cardColorsBg() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "dark";
      } else {
        return "secondary";
      }
    },
    cardColorsText() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "white";
      } else {
        return "dark";
      }
    },
    statusOverall() {
      let index = null;
      let temp = null;
      if (this.data.seDetails != null) {
        index = this.data.seDetails.LifeCycleData.OverallRisk.indexOf("%");
        temp = this.data.seDetails.LifeCycleData.OverallRisk.split("%");
      } else {
        index = this.data.seDetailsOld["Risk.Overall"].indexOf("%");
        temp = this.data.seDetailsOld["Risk.Overall"].split("%");
      }

      if (index > -1) {
        if (temp[0] <= this.globalSettings.SERiskRange1) {
          return "success";
        } else if (temp[0] > this.globalSettings.SERiskRange2) {
          return "danger";
        } else if (
          temp[0] < this.globalSettings.SERiskRange2 &&
          temp[0] > this.globalSettings.SERiskRange1
        ) {
          return "warning";
        }
      }
      return "warning";
    },
    statusInventory() {
      let temp = null;

      if (this.data.seDetails != null) {
        temp = this.data.seDetails.RiskData.InventoryRisk;
      } else {
        temp = this.data.seDetailsOld["Risk.Inventory"];
      }

      if (temp == "Low") {
        return "success";
      }
      if (temp == "Medium") {
        return "warning";
      }
      if (temp == "High") {
        return "danger";
      }
      return "";
    },
    statusLifecycleRisk() {
      let temp = null;

      if (this.data.seDetails != null) {
        temp = this.data.seDetails.RiskData.LifecycleRisk;
      } else {
        temp = this.data.seDetailsOld["Risk.Lifecycle"];
      }

      if (temp == "Low") {
        return "success";
      }
      if (temp == "Medium") {
        return "warning";
      }
      if (temp == "High") {
        return "danger";
      }
      return "";
    },
    statusMultiSourcing() {
      let temp = null;

      if (this.data.seDetails != null) {
        temp = this.data.seDetails.RiskData.MultiSourcingRisk;
      } else {
        temp = this.data.seDetailsOld["Risk.MultiSourcing"];
      }

      if (temp == "High") {
        return "success";
      }
      if (temp == "Medium") {
        return "warning";
      }
      if (temp == "Low") {
        return "danger";
      }
      return "";
    },
    statusNumberOfDistributors() {
      let temp = null;

      if (this.data.seDetails != null) {
        temp = this.data.seDetails.RiskData.NumberOfDistributors;
      } else {
        temp = this.data.seDetailsOld["Risk.NumberOfDistributors"];
      }

      if (temp <= 2) {
        return "danger";
      } else if (temp > 5) {
        return "success";
      } else if (temp <= 5 && temp > 2) {
        return "warning";
      }

      return "";
    },
    statusYearsEOL() {
      let value = null;

      if (this.data.seDetails != null) {
        value = parseFloat(this.data.seDetails.RiskData.YearsEOL);
      } else {
        value = parseFloat(this.data.seDetailsOld["Risk.YearsEOL"]);
      }

      let range1 = parseFloat(this.globalSettings.SEEOLRange1);
      let range2 = parseFloat(this.globalSettings.SEEOLRange2);

      if (value <= range1) {
        return "danger";
      } else if (value > range2) {
        return "success";
      } else if (value <= range2 && value > range1) {
        return "warning";
      }

      return "gray";
    },
    statusRohsRisk() {
      let temp = null;

      if (this.data.seDetails != null) {
        temp = this.data.seDetails.RiskData.RohsRisk;
      } else {
        temp = this.data.seDetailsOld["Risk.RohsRisk"];
      }

      if (temp == "Low") {
        return "success";
      }
      if (temp == "Medium") {
        return "warning";
      }
      if (temp == "High") {
        return "danger";
      }
      return "gray";
    },
    // statusLifecycle() {
    //   if (this.data["Lifecycle"] == "Active") {
    //     return "success";
    //   }

    //   return "danger";
    // },
    statusEstimatedYearsToEOL() {
      // if (this.data["Lifecycle.EstimatedYearsToEOL"] < 2) {
      //   return "danger";
      // } else if (this.data["Lifecycle.EstimatedYearsToEOL"] > 5) {
      //   return "success";
      // } else if (
      //   !(this.data["Lifecycle.EstimatedYearsToEOL"] <= 5) &&
      //   !(this.data["Risk.YearsEOL"] >= 2)
      // ) {
      //   return "warning";
      // }

      let value = null;

      if (this.data.seDetails != null) {
        value = parseFloat(this.data.seDetails.LifeCycleData.EstimatedYearsToEOL);
      } else {
        value = parseFloat(this.data.seDetailsOld["Lifecycle.EstimatedYearsToEOL"]);
      }

      let range1 = parseFloat(this.globalSettings.SEEOLRange1);
      let range2 = parseFloat(this.globalSettings.SEEOLRange2);

      if (value <= range1) {
        return "danger";
      } else if (value > range2) {
        return "success";
      } else if (value <= range2 && value > range1) {
        return "warning";
      }

      return "";
    },
    statusPartStatus() {
      let temp = null;

      if (this.data.seDetails != null) {
        temp = this.data.seDetails.LifeCycleData.PartStatus;
      } else {
        temp = this.data.seDetailsOld["Lifecycle.PartStatus"];
      }

      if (temp == "Active") {
        return "success";
      }
      
      if (temp == "Obsolete") {
        return "danger";
      }
      return "gray";
    },
  },
  created() {
    this.prepareData();
  },
  watch: {
    value: function (newVal, oldVal) {},
  },

  methods: {
    prepareData() {
      
      if (this.data.seDetails != null) {
        this.dataBasic.MPN = this.data.seDetails.SummaryData.PartNumber;
        this.dataBasic.Manufacturer = this.data.seDetails.SummaryData.Manufacturer;

        this.readyData = {
          OverallRisk: this.data.seDetails.LifeCycleData.OverallRisk,
          LifecycleRisk: this.data.seDetails.RiskData.LifecycleRisk,
          InventoryRisk: this.data.seDetails.RiskData.InventoryRisk,
          LastUpdateDate: this.data.seDetails.RiskData.LastUpdateDate,
          LifecycleStage: this.data.seDetails.RiskData.LifecycleStage,
          MultiSourcingRisk: this.data.seDetails.RiskData.MultiSourcingRisk,
          NumberOfDistributors: this.data.seDetails.RiskData.NumberOfDistributors,
          NumberOfOtherSources: this.data.seDetails.RiskData.NumberOfOtherSources,
          PredictedObsolescenceYear: this.data.seDetails.RiskData
            .PredictedObsolescenceYear,
          RohsRisk: this.data.seDetails.RiskData.RohsRisk,
          SEGrade: this.data.seDetails.RiskData.SEGrade,
          YearsEOL: this.data.seDetails.RiskData.YearsEOL,

          PartStatus: this.data.seDetails.LifeCycleData.PartStatus,
          MinimumEstimatedYearsToEOL: this.data.seDetails.LifeCycleData
            .MinimumEstimatedYearsToEOL,
          MaximumEstimatedYearsToEOL: this.data.seDetails.LifeCycleData
            .MaximumEstimatedYearsToEOL,
          LTBDate: this.data.seDetails.LifeCycleData.LTBDate,
          EstimatedYearsToEOL: this.data.seDetails.LifeCycleData.EstimatedYearsToEOL,
          EstimatedEOLDate: this.data.seDetails.LifeCycleData.EstimatedEOLDate,
          RiskGrade: this.data.seDetails.LifeCycleData.LifeCycleRiskGrade,
          YeolComment: this.data.seDetails.RiskData.YeolComment,
        };
      } else {
        this.dataBasic.MPN = this.data.seDetailsOld["MPN"];
        this.dataBasic.Manufacturer = this.data.seDetailsOld["Manufacturer"];

        this.readyData = {
          OverallRisk: this.data.seDetailsOld["Risk.Overall"],
          LifecycleRisk: this.data.seDetailsOld["Risk.Lifecycle"],
          InventoryRisk: this.data.seDetailsOld["Risk.Inventory"],
          LastUpdateDate: this.data.seDetailsOld["Risk.LastUpdateDate"],
          LifecycleStage: this.data.seDetailsOld["Risk.LifecycleStage"],
          MultiSourcingRisk: this.data.seDetailsOld["Risk.MultiSourcing"],
          NumberOfDistributors: this.data.seDetailsOld["Risk.NumberOfDistributors"],
          NumberOfOtherSources: this.data.seDetailsOld["Risk.NumberOfOtherSources"],
          PredictedObsolescenceYear: this.data.seDetailsOld[
            "Risk.PredictedObsolescenceYear"
          ],
          RohsRisk: this.data.seDetailsOld["Risk.RohsRisk"],
          SEGrade: this.data.seDetailsOld["Risk.SEGrade"],
          YearsEOL: this.data.seDetailsOld["Risk.YearsEOL"],

          PartStatus: this.data.seDetailsOld["Lifecycle.PartStatus"],
          MinimumEstimatedYearsToEOL: this.data.seDetailsOld[
            "Lifecycle.MinimumEstimatedYearsToEOL"
          ],
          MaximumEstimatedYearsToEOL: this.data.seDetailsOld[
            "Lifecycle.MaximumEstimatedYearsToEOL"
          ],
          LTBDate: this.data.seDetailsOld["Lifecycle.LTBDate"],
          EstimatedYearsToEOL: this.data.seDetailsOld["Lifecycle.EstimatedYearsToEOL"],
          EstimatedEOLDate: this.data.seDetailsOld["Lifecycle.EstimatedEOLDate"],
          YeolComment: this.data.seDetailsOld["Lifecycle.YeolComment"],
        };
      }
    },
  },
};
</script>

<style scoped>
.card {
  border: solid 1px;
  margin: 8px;
}
.cardBorder {
  font-size: 18px;
}
.cardBorderComment {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SERiskComponent.vue